"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sidebar = _interopRequireDefault(require("./sidebar.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Sidebar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Sidebar, _React$Component);

  function Sidebar(props) {
    var _this;

    _classCallCheck(this, Sidebar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sidebar).call(this, props));
    _this.state = {
      filter: ''
    };
    return _this;
  }

  _createClass(Sidebar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var filter = this.state.filter;
      var _this$props = this.props,
          logo = _this$props.logo,
          open = _this$props.open,
          partials = _this$props.partials;
      var Credits = partials.Credits,
          Filter = partials.Filter,
          Logo = partials.Logo,
          Menu = partials.Menu;
      return _react["default"].createElement("div", {
        className: "".concat(_sidebar["default"]['sidebar'], " ").concat(open ? _sidebar["default"]['open'] : '')
      }, _react["default"].createElement(Logo, {
        src: logo
      }), _react["default"].createElement(Filter, {
        onInput: function onInput(e) {
          return _this2.setState({
            filter: e.target.value
          });
        }
      }), _react["default"].createElement(Menu, {
        filter: filter
      }), _react["default"].createElement(Credits, null));
    }
  }]);

  return Sidebar;
}(_react["default"].Component);

Sidebar.propTypes = {
  partials: _propTypes["default"].shape({
    Credits: _propTypes["default"].func.isRequired,
    Filter: _propTypes["default"].func.isRequired,
    Logo: _propTypes["default"].func.isRequired,
    Menu: _propTypes["default"].func.isRequired
  }).isRequired,
  sections: _propTypes["default"].array
};
Sidebar.defaultProps = {
  sections: []
};
var _default = Sidebar;
exports["default"] = _default;